import { useMemo } from 'react';
import type React from 'react';

import { Avatar, Card, CardBody, Text } from '@change/ds-core-ui';

import { useNow } from '@change-corgi/core-react/date';
import { useI18n } from '@change-corgi/core-react/i18n';

import { usePetitionActionsPageState } from '#src/app/pages/actions/pageContext';

export const YourVoiceText: React.FC = () => {
	const [{ supporterVoices, newSupporterVoiceId }] = usePetitionActionsPageState();
	const supporterVoice = useMemo(
		() => supporterVoices.find((candidate) => candidate.id === newSupporterVoiceId),
		[supporterVoices, newSupporterVoiceId],
	);
	const { localizeRelativeTime } = useI18n();
	const now = useNow();

	return (
		<div className="mb-4">
			<Card>
				<CardBody>
					<div className="ml-2 flex flex-col gap-2">
						<div className="flex items-center gap-2">
							<Avatar alt="avatar" size={24} src={supporterVoice?.user.photo?.userSmall.url} />
							<Text variant="body" size="small" fontWeight="bold" className="text-typography-strong">
								{supporterVoice?.user.shortDisplayName}
							</Text>
							<Text variant="body" size="x-small" className="text-typography-weak ml-auto">
								{localizeRelativeTime(now, now.valueOf() - 1_000)}
							</Text>
						</div>
						<Text
							variant="body"
							size="small"
							as="p"
							data-testid="supporter-voice-text"
							className="text-typography-strong text-left wrap-break-word"
						>
							{supporterVoice?.text}
						</Text>
					</div>
				</CardBody>
			</Card>
		</div>
	);
};
